"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../scripts/types");
exports.default = {
    ANALYTICS_EXPLORER_PAGE: [
        {
            entitlement: "B2B2024_PageAnalyticsExplorer",
            // eventually remove below line to release to everyone with B2B2024_PageAnalyticsExplorer entitlement
            launchDarkly: "dev-analytics-explore-v1",
            accessAllowList: {
                // only admins and managers should have access to analytics explorer
                userRoles: [types_1.UserRoles.Admin, types_1.UserRoles.Manager],
            },
        },
        {
            launchDarkly: "b2b-app-trustie-access-market-insights",
            userRoles: [types_1.UserRoles.Admin, types_1.UserRoles.Manager],
        },
        {
            launchDarkly: "b2b-analytics-explorer-external-user-access",
            userRoles: [types_1.UserRoles.Admin, types_1.UserRoles.Manager],
        },
    ],
    WIDGET_DASHBOARD_PAGE: [
        {
            entitlement: "B2B2024_PageWidgetsDashboard",
            launchDarkly: "dev-widget-dashboard-v1",
            accessAllowList: {
                userRoles: [types_1.UserRoles.Admin, types_1.UserRoles.Manager],
            },
        },
    ],
};
//# sourceMappingURL=analytics-explorer.js.map